import type { Attribution } from "services/attribution";
import { PurchaseStudentType } from "./pricingModel/model";
import { api } from "./restUtil";

type StartOAuthResponse = {
  url: string;
};

type StartAuthPayload = {
  pricing_model_code?: string | null;
  student_type: PurchaseStudentType;
  return_path?: string;
  attribution?: Attribution;
};

export async function startOAuth(provider: OAuthProvider, payload: StartAuthPayload) {
  return api.post<StartAuthPayload, StartOAuthResponse>(
    `/login/oauth/${provider}`,
    payload
  );
}

export interface OAuthUserInfo {
  id: string;
  email: string;
  mfa: boolean;
  status: string;
  token: string;
  return_path?: string;
}

export interface ConfirmOAuthResponse {
  user?: OAuthUserInfo;
  verify_email?: boolean;
  is_new_user?: boolean;
}

export function confirmOAuth(
  provider: OAuthProvider,
  params: Record<string, string>
): Promise<ConfirmOAuthResponse> {
  return api.post<Record<string, string>, ConfirmOAuthResponse>(
    `/login/oauth/${provider}/callback`,
    params
  );
}

interface VerifyEmailRequest {
  token: string;
}

export function verifyEmail(token: string): Promise<OAuthUserInfo> {
  return api.post<VerifyEmailRequest, OAuthUserInfo>("/login/oauth/verify/email", {
    token,
  });
}

export enum OAuthProvider {
  GOOGLE = "google",
  LINKEDIN = "linkedin",
  APPLE = "apple",
  META = "meta",
}

export enum OAuthStep {
  Start = "start",
  Confirm = "confirm",
  VerifyEmail = "verify_email",
  PostConfirm = "post_confirm",
}
